<template>
    <v-tabs
        background-color="#467FA5"
        color="white"
    >
        <slot></slot>
    </v-tabs>
</template>

<script>
export default {
    name: "PsTabs",
    props: {

    },
    data() {
        return {

        };
    },
    mounted() {
        var slots = this.$slots.default;
   
        slots.forEach(s => {
            if(typeof(s.tag) !== "undefined") {
		        if(s.tag.indexOf("-PsTab") >= 0) {
                    if(typeof(s.componentOptions.propsData.active !== "undefined") && s.componentOptions.propsData.active === true) {
                        s.elm.classList.add("v-tab--active");
                    } else {
                        s.elm.classList.remove("v-tab--active");
                    }
		        }
            }
        });
    }
};
</script>